import { render, staticRenderFns } from "./CaDataBg.vue?vue&type=template&id=1768210f&"
import script from "./CaDataBg.vue?vue&type=script&lang=ts&"
export * from "./CaDataBg.vue?vue&type=script&lang=ts&"
import style0 from "./CaDataBg.vue?vue&type=style&index=0&id=1768210f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports